// extracted by mini-css-extract-plugin
module.exports = {"button":"AscDescBtn_button__2S_Ln","buttons_block":"AscDescBtn_buttons_block__2EKiH"};